<template>
  <div class="page">
    <div class="hd">
      <span @click.stop="$router.back()" to="/" class="backup actable">
        <span class="iconfont iconpre"> </span>返回列表
      </span>
      <span class="title-mag">搜索</span>
    </div>
    <slot></slot>
    <slot name="ft"></slot>
  </div>
</template>
<script>
export default {
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
